import React from 'react';
import type { QuizPlayerScore } from '@mentimeter/quiz-types';

const MAX_LEADERBOARD_LENGTH = 10;
const BAD_WORD_REPLACEMENT = '!#*&!$';

const maskProfanity = (source: string, isProfanity: boolean): string =>
  isProfanity ? BAD_WORD_REPLACEMENT : source;

export const useLeaderboardResults = (
  results: QuizPlayerScore[] | undefined,
): QuizPlayerScore[] | undefined => {
  return React.useMemo(() => {
    if (!results) return;

    return results
      .sort((a, b) => {
        return a.score.total.position - b.score.total.position;
      })
      .slice(0, MAX_LEADERBOARD_LENGTH)
      .map((r) => {
        return {
          ...r,
          player: {
            ...r.player,
            name: r.player.name
              ? maskProfanity(r.player.name, Boolean(r.isPlayerNameProfanity))
              : null,
          },
        };
      });
  }, [results]);
};
